import { qs, qsa, contains } from "@fluorescent/dom";
import {
  FadeUpReveal,
  FadeScaleReveal,
  FadeUpSplitReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  socialProofItems: ".social-proof__slide",
  headerRevealItem:
    ".section-header .animation-fade-up-split-reveal, .section-header .animation-fade-up-reveal",
};

export default node => {
  let observer = null;
  const socialProofItems = qsa(selectors.socialProofItems, node);
  const headerRevealItems = qsa(selectors.headerRevealItem, node);
  const headerReveals = [];
  const slideReveals = [];

  if (shouldAnimate(node)) {
    headerRevealItems.forEach(revealItem => {
      // check which type of reveal needs to be initialized
      if (contains(revealItem, "animation-fade-up-split-reveal")) {
        headerReveals.push(new FadeUpSplitReveal(revealItem));
      } else if (contains(revealItem, "animation-fade-up-reveal")) {
        headerReveals.push(new FadeUpReveal(revealItem));
      }
    });
    socialProofItems.forEach(item => {
      if (contains(item, "is-visible")) {
        const slideItemReveals = [];
        const image = qs(".image", item);
        if (image) {
          slideItemReveals.push(new FadeScaleReveal(image));
        }

        qsa(".social-proof__item-likes, .social-proof__content", item).forEach(
          revealItem => {
            slideItemReveals.push(new FadeUpReveal(revealItem));
          }
        );

        slideReveals.push(slideItemReveals);
      }
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    let delay = 0;
    headerReveals.forEach(reveal => {
      reveal.play(delay);

      if (reveal.type === "FadeUpSplitReveal") {
        delay += reveal.lineCount * window.theme.animation.delay;
      } else {
        delay += window.theme.animation.delay;
      }
    });

    slideReveals.forEach(slide => {
      let slideDelay = delay;
      slide.forEach(reveal => {
        reveal.play(slideDelay);
        slideDelay += window.theme.animation.delay;
      });
      delay += window.theme.animation.delay;
    });
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
